import { render, staticRenderFns } from "./createSettlement.vue?vue&type=template&id=5c683d46&scoped=true&"
import script from "./createSettlement.vue?vue&type=script&lang=js&"
export * from "./createSettlement.vue?vue&type=script&lang=js&"
import style0 from "./createSettlement.vue?vue&type=style&index=0&id=5c683d46&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c683d46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c683d46')) {
      api.createRecord('5c683d46', component.options)
    } else {
      api.reload('5c683d46', component.options)
    }
    module.hot.accept("./createSettlement.vue?vue&type=template&id=5c683d46&scoped=true&", function () {
      api.rerender('5c683d46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/rewardPayment/createSettlement.vue"
export default component.exports